import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProductPage from './tpss/pages/ProductList';
import ProductVersionDetails from './tpss/pages/ProductVersionDetails';

interface IAppProps {
  layout: React.ReactNode;
}

const App: React.FC<IAppProps> = ({ layout }) => {
  return (
    <Routes>
      <Route element={layout}>
        <Route path="/" element={<Navigate to="product" replace />}></Route>
        <Route path="/product" element={<ProductPage />}></Route>
        <Route path="/product/:id" element={<ProductVersionDetails />}></Route>
        <Route
          path="/product/:id/package/:pid"
          element={<ProductVersionDetails />}
        ></Route>
      </Route>
    </Routes>
  );
};

export default App;
